<template>
    <Modal @on-ok="done" @on-cancel="done(true)" v-model="isShow" :title="title" :ok-text="okText" :cancel-text="cancelText">
        <Form ref="form" :model="form" :rules="rules">
            <FormItem prop="input" :label="label" style="margin-bottom: 0">
                <Select ref="input" v-if="type == 'select'" v-model="form.input">
                    <Option v-for="(item, index) in items" :key="index" :value="item.value">{{item.text}}</Option>
                </Select>
                <Input ref="input" v-else v-model="form.input" show-word-limit :maxlength="maxlength" clearable autofocus/>
            </FormItem>
        </Form>
        <p v-if="tips!=null" style="color:red;margin-top:10px"><span v-html="tips"></span></p>
    </Modal>
</template>
<script>
// 在 helper.js 里面的 prompt 使用这个 vue 单页
import i18n from '@/main';
export default {
    data() {
        return {
            title: "",
            type: 'input',
            label: '',
            value: null,
            items: [],
            isShow: false,
            form: { input: "" },
            maxlength: 1024,
            okText: "确定",
            cancelText: "取消",
            notempty: true,
            requiredMsg: "不能为空",
            tips: null
        };
    },
    computed: {
        rules() {
            return {
                input: [
                    {
                        required: this.notempty,
                        message: this.requiredMsg,
                        trigger: "blur",
                        type: this.type == 'select' ? 'number' : 'string'
                    }
                ]
            }
        }
    },
    methods: {
        done(cancel) {
            if (cancel) {
                this.$emit("hide");
            } else {
                this.$refs.form.validate(valid => {
                    if (valid) this.$emit("hide", this.form.input);
                    else
                        this.$nextTick(() => {
                            this.isShow = true;
                        });
                });
            }
        },
        show(_title, options) {
            this.maxlength = options.maxlength || 1024;
            if (options.notempty === undefined) this.notempty = true;
            else this.notempty = options.notempty;

            this.title = _title;
            this.type = options.type;
            this.value = options.value;
            this.label = options.label || '';
            this.items = options.items ||[];
            this.tips = options.tips || null;
            this.isShow = true;
            this.reset();
            this.$nextTick(() => {
                if(this.type == 'input') {
                    this.$refs.form.resetFields();
                    this.$refs.input.focus();
                }
                this.okText = i18n.t("Button.confirm");
                this.cancelText = i18n.t("Button.cancel");
                this.requiredMsg = i18n.t("Message.notempty");
            });
        },
        reset() {
            if(this.type == 'select') {
                this.form.input = this.value == null ? null : this.value;
            } else {
                this.form.input = this.value || "";
            }
        }
    }
};
</script>

